import { __extends, __decorate, __metadata } from 'tslib';
import { Model, Prop, Component, Vue } from 'vue-property-decorator';
import 'reflect-metadata';
import clsx from 'clsx';
import __vue_component__ from './HseModal.vue.js';

var HseModalInfo = /** @class */ (function (_super) {
    __extends(HseModalInfo, _super);
    function HseModalInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HseModalInfo.prototype, "modalClassComputed", {
        get: function () {
            return clsx('hse-ModalInfo', this.modalClass);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Model('toggle'),
        __metadata("design:type", Boolean)
    ], HseModalInfo.prototype, "open", void 0);
    __decorate([
        Prop({
            default: true
        }),
        __metadata("design:type", Boolean)
    ], HseModalInfo.prototype, "shouldCloseOnOverlayClick", void 0);
    __decorate([
        Prop({
            default: true
        }),
        __metadata("design:type", Boolean)
    ], HseModalInfo.prototype, "shouldCloseOnEsc", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", String)
    ], HseModalInfo.prototype, "title", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", Object)
    ], HseModalInfo.prototype, "modalClass", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", Object)
    ], HseModalInfo.prototype, "modalStyle", void 0);
    __decorate([
        Prop({
            default: function () { return ({
                title: '',
                content: ''
            }); }
        }),
        __metadata("design:type", Object)
    ], HseModalInfo.prototype, "classes", void 0);
    HseModalInfo = __decorate([
        Component({
            name: 'HseModalInfo',
            components: { HseModal: __vue_component__ }
        })
    ], HseModalInfo);
    return HseModalInfo;
}(Vue));

export default HseModalInfo;
